import type { ComponentProps } from 'react';

const ChevronRight = ({
  color = '#B6AEA3',
  ...rest
}: ComponentProps<'svg'>) => (
  <svg
    aria-label="Chevron right icon"
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...rest}
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      d="m6 12 4-4-4-4"
    />
  </svg>
);

export default ChevronRight;
